import React, { useState, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaPlay, FaPause, FaVolumeUp, FaVolumeMute, FaExpand } from 'react-icons/fa';
import  '../../../assets/css/customer/home/VedioSection.css';

const VedioSection = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [showControls, setShowControls] = useState(true);

  // Play/Pause toggle
  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  // Mute/Unmute toggle
  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  // Fullscreen toggle
  const toggleFullscreen = () => {
    if (videoRef.current) {
      if (videoRef.current.requestFullscreen) {
        videoRef.current.requestFullscreen();
      } else if (videoRef.current.webkitRequestFullscreen) {
        videoRef.current.webkitRequestFullscreen();
      } else if (videoRef.current.msRequestFullscreen) {
        videoRef.current.msRequestFullscreen();
      }
    }
  };

  // Video ended
  const handleVideoEnd = () => {
    setIsPlaying(false);
  };

  return (
    <section className="video-section">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} md={12}>
            {/* Section Heading */}
            <div className="video-header">
              <h2 className="video-title">Watch Our Story</h2>
              <p className="video-subtitle">
                Experience the magic of perfect weddings through our lens
              </p>
            </div>

            {/* Video Container */}
            <div 
              className="video-container"
              onMouseEnter={() => setShowControls(true)}
              onMouseLeave={() => isPlaying && setShowControls(false)}
            >
              {/* Video Player */}
              <video
                ref={videoRef}
                className="video-player"
                poster="https://images.unsplash.com/photo-1519741497674-611481863552?w=1200&h=675&fit=crop"
                onEnded={handleVideoEnd}
              >
                <source 
                  src="https://video-previews.elements.envatousercontent.com/h264-video-previews/76fd7cee-67d1-4ebc-bc66-f984ab8d1ad6/33341815.mp4" 
                  type="video/mp4" 
                />
                Your browser does not support the video tag.
              </video>

              {/* Play Button Overlay (when video is not playing) */}
              {!isPlaying && (
                <div className="play-overlay" onClick={togglePlay}>
                  <div className="play-button-large">
                    <FaPlay />
                  </div>
                </div>
              )}

              {/* Video Controls (when video is playing and mouse hover) */}
              {showControls && (
                <div className="video-controls">
                  <div className="controls-left">
                    <button 
                      className="control-btn" 
                      onClick={togglePlay}
                      aria-label={isPlaying ? "Pause" : "Play"}
                    >
                      {isPlaying ? <FaPause /> : <FaPlay />}
                    </button>

                    <button 
                      className="control-btn" 
                      onClick={toggleMute}
                      aria-label={isMuted ? "Unmute" : "Mute"}
                    >
                      {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
                    </button>
                  </div>

                  <div className="controls-right">
                    <button 
                      className="control-btn" 
                      onClick={toggleFullscreen}
                      aria-label="Fullscreen"
                    >
                      <FaExpand />
                    </button>
                  </div>
                </div>
              )}

              {/* Decorative Elements */}
              <div className="video-decoration video-decoration-top-left"></div>
              <div className="video-decoration video-decoration-bottom-right"></div>
            </div>

            {/* Video Description */}
            <div className="video-description">
              <p>
                Discover how we transform dreams into reality. From intimate ceremonies 
                to grand celebrations, every moment is crafted with love and attention to detail.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default VedioSection;